import { Children } from '@/utils/reactTypes';
import { Box } from '@mui/material';
import { SystemProps } from '@mui/system/Box/Box';
import React from 'react';

export const VerticallyCenterChildren = ({ children, ...rest }: { children: Children }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
        }}
        {...rest}
    >
        {children}
    </Box>
);

export const HorizontallyCenterChildren = ({ children }: { children: Children }) => (
    <Box
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}
    >
        {children}
    </Box>
);

export const centerChildren: SystemProps = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};
